/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Totalvalue2Inputs */

const id_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Nilai`)
};

const ms_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah Nilai`)
};

const da_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet Værdi`)
};

const de_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtwert`)
};

const en_us2_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Value`)
};

const es_es2_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor Total`)
};

const es_mx2_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total`)
};

const fil_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang Halaga`)
};

const fr_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur totale`)
};

const it_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore totale`)
};

const hu_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes érték`)
};

const nl_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale waarde`)
};

const no_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total verdi`)
};

const pl_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna wartość`)
};

const pt_br2_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Value`)
};

const pt_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total`)
};

const ro_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoare totală`)
};

const fi_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokonaisarvo`)
};

const sv_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totala värdet`)
};

const vi_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng giá trị`)
};

const tr_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam Değer`)
};

const cs_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celková hodnota`)
};

const bg_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обща стойност`)
};

const ru_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая стоимость`)
};

const uk_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна вартість`)
};

const ar_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيمة الإجمالية`)
};

const hi_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल मूल्य`)
};

const th_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มูลค่ารวม`)
};

const ja_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計価値`)
};

const zh_cn2_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Value`)
};

const zh_hant1_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Value`)
};

const ko_components_giveawaystats_totalvalue2 = /** @type {(inputs: Components_Giveawaystats_Totalvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Value`)
};

/**
* | output |
* | --- |
* | "Total Value" |
*
* @param {Components_Giveawaystats_Totalvalue2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_totalvalue2 = /** @type {((inputs?: Components_Giveawaystats_Totalvalue2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Totalvalue2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_totalvalue2(inputs)
	if (locale === "ms") return ms_components_giveawaystats_totalvalue2(inputs)
	if (locale === "da") return da_components_giveawaystats_totalvalue2(inputs)
	if (locale === "de") return de_components_giveawaystats_totalvalue2(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_totalvalue2(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_totalvalue2(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_totalvalue2(inputs)
	if (locale === "fil") return fil_components_giveawaystats_totalvalue2(inputs)
	if (locale === "fr") return fr_components_giveawaystats_totalvalue2(inputs)
	if (locale === "it") return it_components_giveawaystats_totalvalue2(inputs)
	if (locale === "hu") return hu_components_giveawaystats_totalvalue2(inputs)
	if (locale === "nl") return nl_components_giveawaystats_totalvalue2(inputs)
	if (locale === "no") return no_components_giveawaystats_totalvalue2(inputs)
	if (locale === "pl") return pl_components_giveawaystats_totalvalue2(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_totalvalue2(inputs)
	if (locale === "pt") return pt_components_giveawaystats_totalvalue2(inputs)
	if (locale === "ro") return ro_components_giveawaystats_totalvalue2(inputs)
	if (locale === "fi") return fi_components_giveawaystats_totalvalue2(inputs)
	if (locale === "sv") return sv_components_giveawaystats_totalvalue2(inputs)
	if (locale === "vi") return vi_components_giveawaystats_totalvalue2(inputs)
	if (locale === "tr") return tr_components_giveawaystats_totalvalue2(inputs)
	if (locale === "cs") return cs_components_giveawaystats_totalvalue2(inputs)
	if (locale === "bg") return bg_components_giveawaystats_totalvalue2(inputs)
	if (locale === "ru") return ru_components_giveawaystats_totalvalue2(inputs)
	if (locale === "uk") return uk_components_giveawaystats_totalvalue2(inputs)
	if (locale === "ar") return ar_components_giveawaystats_totalvalue2(inputs)
	if (locale === "hi") return hi_components_giveawaystats_totalvalue2(inputs)
	if (locale === "th") return th_components_giveawaystats_totalvalue2(inputs)
	if (locale === "ja") return ja_components_giveawaystats_totalvalue2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_totalvalue2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_totalvalue2(inputs)
	return ko_components_giveawaystats_totalvalue2(inputs)
});
export { components_giveawaystats_totalvalue2 as "components.giveawayStats.totalValue" }